"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlameDiscountBlue = function SvgFlameDiscountBlue(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.05 11.974c-.024.272-.65 4.828-6.173 5.518-8.942.22-7.642-8.586-7.014-9.807.034.88.201 1.963 1.17 2.21-1.032-4.809 1.7-6.939 1.7-6.939.261.785 1.543 2.32 1.637 2.406 1.088 1.016 2.893 2.312 3.94 1.934.755-.273-.335-3.237-.335-3.237 3.93 1.303 5.4 4.108 5.074 7.915Z",
    stroke: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.218 14.125c.52 0 .942-.431.942-.963a.953.953 0 0 0-.942-.964.953.953 0 0 0-.942.964c0 .532.422.963.942.963Zm-3.23-3.028c.52 0 .942-.432.942-.964a.953.953 0 0 0-.942-.964.953.953 0 0 0-.941.964c0 .532.421.964.941.964Z",
    stroke: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.242 14.451 4.386-5.26",
    stroke: "#007AFF"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFlameDiscountBlue);
var _default = Memo;
exports["default"] = _default;